'use client';

// Handle `?join=1` from an invite link on /live: signed-out → sign-in with ?next= back to the
// same room; signed-in → welcome toast, and only the `join` flag is stripped from the URL so
// the selected room (`?room=XAUUSD`) survives a refresh.
import { useEffect } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/AuthContext';

export function useJoinParam(welcome: string) {
  const { user, loading } = useAuth();
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const join = searchParams?.get('join') === '1';
  useEffect(() => {
    if (!join || loading) return;
    const here = `${pathname}${searchParams?.toString() ? `?${searchParams.toString()}` : ''}`;
    if (!user) {
      router.replace(`/sign-up-login-screen?next=${encodeURIComponent(here)}`);
      return;
    }
    toast.success(welcome);
    const rest = new URLSearchParams(searchParams?.toString());
    rest.delete('join');
    router.replace(rest.toString() ? `${pathname}?${rest.toString()}` : pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [join, loading, user?.id, pathname]);
}
